const forumRoute = [
  {
    path: '/forum/pgc-list',
    name: 'PGCList',
    authed: 'PGCList',
    component: () => import('@/views/forum/PGClist/index.vue'),
    meta: {
      tabName: 'PGC List',
      group: 'Forum Mgmt.',
      title: 'PGC List',
      icon: 'mdiHeart',
      groupSort: 20, // 菜单排序,每个路由文件只需写一个
    },
  },
  {
    path: '/forum/pgc-list/pgc-detail',
    name: 'PGCDetail',
    authed: 'PGCDetail',
    component: () => import('@/views/forum/PGClist/pgcDetail.vue'),
    meta: {
      tabName: 'PGC DETAIL',
      group: 'Forum Mgmt.',
      isHide: true,
    },
  },
  {
    path: '/forum/pgc-list/new-pgc',
    name: 'NewPgc',
    authed: 'NewPgc',
    component: () => import('@/views/forum/PGClist/newPgc.vue'),
    meta: {
      tabName: 'PGC Detail Edit',
      group: 'Forum Mgmt.',
      isHide: true,
      canEdit: true, // 标识是否是可编辑页面 用来做关闭提示需要
    },
  },
  {
    path: '/forum/pgc-list/edit-pgc',
    name: 'EditPgc',
    authed: 'EditPgc',
    component: () => import('@/views/forum/PGClist/editPgc.vue'),
    meta: {
      tabName: 'PGC Detail Edit',
      group: 'Forum Mgmt.',
      isHide: true,
      canEdit: true,
    },
  },
  {
    path: '/forum/ugc-list',
    name: 'UGCList',
    authed: 'UGCList',
    component: () => import('@/views/forum/UGClist/index.vue'),
    meta: {
      tabName: 'UGC List',
      group: 'Forum Mgmt.',
      title: 'UGC List',
    },
  },
  {
    path: '/forum/ugc-list/ugc-detail',
    name: 'UGCDetail',
    authed: 'UGCDetail',
    component: () => import('@/views/forum/UGClist/ugcDetail.vue'),
    meta: {
      tabName: 'UGC DETAIL',
      group: 'Forum Mgmt.',
      isHide: true,
    },
  },
  {
    path: '/forum/topic-list',
    name: 'TOPIClist',
    authed: 'TOPIClist',
    component: () => import('@/views/forum/TOPIClist/index.vue'),
    meta: {
      tabName: 'Topic List',
      group: 'Forum Mgmt.',
      title: 'Topic List',
    },
  },
  {
    path: '/forum/topic-list/topic-info',
    name: 'TOPICInfo',
    authed: 'TOPICInfo',
    component: () => import('@/views/forum/TOPIClist/topicInfo/index.vue'),
    meta: {
      tabName: 'TOPIC INFO',
      group: 'Forum Mgmt.',
      isHide: true,
    },
  },
  {
    path: '/forum/posts-report',
    name: 'PostsReport',
    authed: 'PostsReport',
    component: () => import('@/views/forum/PostsReport/index.vue'),
    meta: {
      tabName: 'Reported Posts',
      group: 'Forum Mgmt.',
      title: 'REPORTED POSTS',
    },
  },
  {
    path: '/forum/posts-report/report-detail',
    name: 'ReportDetail',
    authed: 'ReportDetail',
    component: () => import('@/views/forum/PostsReport/reportDetail/index.vue'),
    meta: {
      tabName: 'REPORT DETAIL',
      group: 'Forum Mgmt.',
      isHide: true,
    },
  },
  {
    path: '/forum/article-templates',
    name: 'TemplateList',
    authed: 'MEC_TEMPLATE',
    component: () => import('@/views/template/TemplateList.vue'),
    meta: {
      tabName: 'Templates',
      group: 'Forum Mgmt.',
      title: 'TEMPLATES',
    },
  },
  {
    path: '/forum/comment-list',
    name: 'CommentList',
    authed: 'CommentList',
    component: () => import('@/views/forum/CommentList/index.vue'),
    meta: {
      tabName: 'Comment List',
      group: 'Forum Mgmt.',
      title: 'Comment List',
    },
  },
  {
    path: '/forum/article-templates/:id',
    name: 'TemplateDetails',
    authed: 'MEC_TEMPLATE',
    component: () => import('@/views/template/TemplateDetails.vue'),
    meta: {
      tabName: 'Template DETAIL',
      title: 'Template DETAIL',
      group: 'Forum Mgmt.',
      isHide: true,
    },
  },
]

export default forumRoute
// TemplateDetails
